import { createBaseResponseErrors } from '@/utils/errors/baseResponseErrors'
import { createBaseCRUDApi } from '@/api/base'
import { CONTRACT_URL } from '../index'

export const CONTRACT_TYPE_URL = `${CONTRACT_URL}-type`

const errors = createBaseResponseErrors('тип договора', 'типов договоров')

export const ContractTypeApi = createBaseCRUDApi(CONTRACT_TYPE_URL, errors)
